import React, {useMemo} from 'react';
import {LicenseModulesContainer, ModuleIcon, ModuleItem, ModulesList} from "./LicenseModules.styled";
import {useTranslation} from "react-i18next";
import {Typography} from "@mui/material";

import {ReactComponent as OcrSidebarLogo} from "../../../../../assets/icons/ocr_sidebar_logo.svg";
import {ReactComponent as BookOcrLogo} from "../../../../../assets/icons/book_ocr.svg";
import {ReactComponent as DocumentsOcrLogo} from "../../../../../assets/icons/documents_ocr.svg";
import CropFreeIcon from '@mui/icons-material/CropFree';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import FolderSharedOutlinedIcon from '@mui/icons-material/FolderSharedOutlined';
import {LicenseConfigurationData} from "../../../../../models/license.models";


interface LicenseModulesProps {
    configuration: LicenseConfigurationData
}

type ModuleType = {
    name: string,
    available: boolean,
    icon: React.ReactNode,
}

const LicenseModules = ({ configuration }: LicenseModulesProps) => {
    const {t} = useTranslation();
    const { ocr, documentAnalysis, translation, digitalisation, activeDirectory, sharepoint} = configuration;

    const modules: ModuleType[] = useMemo(() => [
        {
            name: t('licenseManager.modules.ocr'),
            available: ocr,
            icon: <OcrSidebarLogo />
        },
        {
            name: t('licenseManager.modules.translations'),
            available: translation,
            icon: <BookOcrLogo />
        },
        {
            name: t('licenseManager.modules.documentAnalysis'),
            available: documentAnalysis,
            icon: <DocumentsOcrLogo />
        },
        {
            name: t('licenseManager.modules.digitization'),
            available: digitalisation,
            icon: <CropFreeIcon />
        },
        {
            name: t('licenseManager.modules.activeDirectory'),
            available: activeDirectory,
            icon: <AccountTreeOutlinedIcon />
        },
        {
            name: t('licenseManager.modules.sharePoint'),
            available: sharepoint,
            icon: <FolderSharedOutlinedIcon />
        },
    ], [t, ocr, documentAnalysis, translation, digitalisation, activeDirectory, sharepoint]);

    const moduleElementRender = (module: ModuleType) => (
        <ModuleItem key={module.name}>
            <ModuleIcon>
                {module.icon}
            </ModuleIcon>

            <Typography variant="subtitle1" component="p" sx={{ color: 'primary', textTransform: 'uppercase', fontWeight: 'medium', letterSpacing: '0.5px' }}>
                {module.name}
            </Typography>
        </ModuleItem>
    );

    return (
        <LicenseModulesContainer>
            <Typography variant="h5" component="div">
                {t('licenseManager.modules.title')}
            </Typography>

            <Typography variant="body1" component="p">
                {t('licenseManager.modules.subtitle')}
            </Typography>

            <ModulesList>
                {modules.map(module => {
                    if (!module.available) return;
                    return moduleElementRender(module);
                })}
            </ModulesList>
        </LicenseModulesContainer>
    );
};

export default LicenseModules;